import type { Visibility } from './visibility.js';

export type SourceType = 'YouTube' | 'X' | 'GitHub' | '記事' | '公式Docs' | 'Web';

export const SOURCE_TYPES: readonly SourceType[] = [
  'YouTube',
  'X',
  'GitHub',
  '記事',
  '公式Docs',
  'Web',
] as const;

export type Importance = '高' | '中' | '低';

export const IMPORTANCE_VALUES: readonly Importance[] = ['高', '中', '低'] as const;

export interface Link {
  id: string;
  title: string;
  url: string;
  sourceType: SourceType;
  domain: string;
  summary: string;
  userComment: string;
  importance: Importance;
  tags: string[];
  projectId?: string | undefined;
  createdBy: string;
  visibility: Visibility;
  /** 外部URL（YouTube ytimg 等） */
  thumbnailUrl?: string | undefined;
  /** Storage 内部キー */
  thumbnailPath?: string | undefined;
  /** チャンネル名・投稿者名（YouTube 等で og 経由自動入力 or 手動入力、任意） */
  channelName?: string | undefined;
  createdAt: Date;
  updatedAt: Date;
}
